import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { DocumentUploadContext } from "@shared-kernel/application/ports/shared/document-upload-provider";

type UploadImagePayload = DocumentUploadContext & { image: File };

export const uploadImage = createApiThunk<string, UploadImagePayload>(
  "images/uploadImage",
  async (payload, { extra: { documentUploadProvider } }) => {
    const { image, ...context } = payload;
    return documentUploadProvider!.uploadImage(image, context);
  },
);

export const resetUploadImage = createAction("images/resetUploadImage");
